import { useState } from "react";

import { EditJsonSchemaModalProps } from "../types";

import { useParameters } from "@/components/ModelParameters/store";
import SchemaEditor from "@/components/SchemaEditor";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const EditJsonSchemaModal = ({
  initialValues,
  handleSubmit,
  readonly = false,
}: EditJsonSchemaModalProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [dialogContentElement, setDialogContentElement] = useState<HTMLDivElement | null>(null);
  const parametersStore = useParameters();

  return (
    <Dialog open={isOpen} onOpenChange={(open: boolean) => setIsOpen(open)}>
      <DialogTrigger asChild>
        <Button variant="outline">{readonly ? "View" : "Edit"} JSON Schema</Button>
      </DialogTrigger>
      <DialogContent
        ref={setDialogContentElement}
        className="flex  max-h-[800px] min-h-[600px] max-w-6xl flex-col px-12"
      >
        <DialogTitle className="pb-2">{readonly ? "View" : "Edit"} JSON Schema</DialogTitle>
        <div className="relative flex flex-1 flex-col overflow-hidden">
          <div className="h-full overflow-y-auto pb-20">
            <SchemaEditor
              schema={initialValues.json}
              onSubmit={e => {
                setIsOpen(false);
                handleSubmit?.(e);
              }}
              readonly={readonly}
              messages={parametersStore.messages}
              aiAssistantPortalContainer={dialogContentElement}
              structuredOutputProviderName={parametersStore.provider?.name}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditJsonSchemaModal;
